// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: "us-east-1",
  aws_cloud_logic_custom: [
    {
      name: "pacreportrestapipublic",
      endpoint: "https://8336ef28nk.execute-api.us-east-1.amazonaws.com/local",
      region: "us-east-1"
    },
    {
      name: "pacreportapirestawsiam",
      endpoint: "https://5u1k27aoz6.execute-api.us-east-1.amazonaws.com/local",
      region: "us-east-1"
    }
  ],
  aws_appsync_graphqlEndpoint:
    "https://53z6oszv2zgwxprxvck7fcodmi.appsync-api.us-east-1.amazonaws.com/graphql",
  aws_appsync_region: "us-east-1",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
  aws_cognito_identity_pool_id:
    "us-east-1:1e652f46-a768-4e46-a620-82c29eddf370",
  aws_cognito_region: "us-east-1",
  aws_user_pools_id: "us-east-1_S6uEOU1ed",
  aws_user_pools_web_client_id: "5o54pqu3916fk6mfavbun0kpep",
  oauth: {},
  aws_mobile_analytics_app_id: "47637a4b77b14d0a88d42608bc92e38e",
  aws_mobile_analytics_app_region: "us-east-1"
};

export default awsmobile;
